import actions from './slide-attributes.actions'
import { mutations } from './slide-attributes.mutations'

const _state = {}

const getters = {
  getCloudImportSource: (state) => (presentationId, slideId) => {
    return state[presentationId]?.[slideId]?.cloudImportSource || null
  },
}

export default {
  namespaced: true,
  actions,
  state: _state,
  mutations,
  getters,
}
